import { render, staticRenderFns } from "./FormInputMagicLink.vue?vue&type=template&id=36b43319&scoped=true"
import script from "./FormInputMagicLink.vue?vue&type=script&lang=ts"
export * from "./FormInputMagicLink.vue?vue&type=script&lang=ts"
import style0 from "./FormInputMagicLink.vue?vue&type=style&index=0&id=36b43319&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b43319",
  null
  
)

export default component.exports